// extracted by mini-css-extract-plugin
export default {"announcement":"Announcement_announcement__prhBE","submit":"Announcement_submit__RwY8z"};